export default class AssetInsuranceSectionCtrl {
  updateCompletion({ isCompleted, isStarted }) {
    this.isCompleted = isCompleted;
    this.isStarted = isStarted;
  }
}
